import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import FileSaver from 'file-saver';
import { AutoComplete, MessageService, SelectItem } from 'primeng';
import { Message } from '../../classes/Message';
import { IChecklistSubCategory } from '../../interfaces/checklist-category';
import { IOrderInfo, ITaskInfo } from '../../interfaces/task-info';
import { ITaskStepPause, ITaskStepResumeInfo } from '../../interfaces/task-step-pause';
import { EmailService, JobsService } from '../../services';
import { MapService } from '../../services';
import { UserService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { JobStatus } from '../job-control/job-screen.component';
import { TaskTypeHelper } from '../../utils/taskType.helper';
import { DelayFailureService } from '../../services/delay-failure.service';
import { DelayFailureAccountabilityEnum } from '../../enums/delay-failure-accountability.enum';
import { ITaskDelayFailure } from '../../interfaces/delay-failure/task-delay-failure';
import { EventService } from '../../services';
import moment from 'moment';
import { IDelayFailureCategory } from 'src/app/interfaces/delay-failure/delay-failure-category';
import { IUser } from 'src/app/interfaces/user';
import { ICommsTemplate } from 'src/app/interfaces/comms-template';
import { ICommsTemplatePreviewResponse } from 'src/app/interfaces/comms-template-preview-response';
import { IDelayFailureTemplate } from 'src/app/interfaces/delay-failure/delay-failure-template';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
import { IJobScreen } from '../../interfaces/job/job';
import { SelectItemWithCount } from '../../interfaces/select-item-with-count';
import { OrganisationTypeEnum } from 'src/app/enums/organisation-types';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { TaskSequenceService } from '../../services/task-sequence.service';

@Component({
  templateUrl: './job-details.component.html',
  selector: 'job-details',
  styleUrls: ['./job-details.component.scss'],
  providers: [TaskTypeHelper],
  encapsulation: ViewEncapsulation.None,
})
export class JobDetailsComponent implements OnInit {
  public DriverLineData: any = {};
  public DriverLineOptions: any = {};
  public BatteryLineData: any = {};
  public BatteryLineOptions: any = {};
  public organisationTypeId: number = 0;
  public TaskTrack: number = 0;

  public FullOrderUrl: string;
  public FullOrderPDFUrl: string;
  public SummaryOrderUrl: string;
  public SummaryOrderPDFUrl: string;
  public subCategory: IChecklistSubCategory;

  public jobStatus_Completed = 1;
  public jobStatus_Invoiced = 2;
  public jobStatus_Closed = 3;
  public jobStatus_Cancelled = 4;
  public jobStatus_Created = 5;
  public jobStatus_Started = 6;
  public jobStatus_Paused = 7;

  public jobStatus: number;

  public showCopyTrackURL: boolean = false;
  public showlblMsg: boolean = false;
  public pauses: ITaskStepPause[] = [];

  @Output() editSupplierSchedule = new EventEmitter();

  @Input() hideTaskSchedule: boolean = false;
  @Input() hideEditLocation: boolean = false;

  @Input('showTaggingInfo') showTaggingInfo: boolean;
  @Input('loadTaskFailures') loadTaskFailures: boolean = false;

  @Input('orgTypeId') orgTypeId: number;

  pdfDownloading: boolean = false;

  /*
  @Input('jobStatus')
  set jobStatus(value: any[]) {
    this.jobStatus = value;
  }
  */

  private _job: IOrderInfo;
  workFlows: any[];

  @Input('job')
  set job(value: IOrderInfo) {
    this._job = value;
    this.refreshJobTasks();
  }

  get job(): IOrderInfo {
    return this._job;
  }

  private _jobInfo: IJobScreen;
  @Input('jobInfo')
  set jobInfo(value: IJobScreen) {
    this._jobInfo = value || null;
  }

  get jobInfo(): IJobScreen {
    return this._jobInfo || null;
  }

  private _jobNumber: string;
  @Input('jobNumber')
  set jobNumber(value: string) {
    this._jobNumber = value;
    this.refreshJobTasks();
  }

  get jobNumber(): string {
    return this._jobNumber;
  }

  private _currentUserOrgTypeId: number;
  @Input('currentUserOrgTypeId')
  set currentUserOrgTypeId(value: number) {
    this._currentUserOrgTypeId = value;
  }

  get currentUserOrgTypeId(): number {
    return this._currentUserOrgTypeId;
  }

  @Input('jobAndTask')
  set jobAndTask(value: any) {
    this._job = value ? value.job : null;
    this.refreshJobTasks(value ? value.taskId : null);
  }

  public tasks: SelectItem[];
  public tasksCopyForSequenceEdit: SelectItem[] = [];

  @Output() selectedTaskChange: EventEmitter<ITaskInfo>;
  private _selectedTask: ITaskInfo;
  @Input('selectedTask')
  set selectedTask(value: ITaskInfo) {
    this._selectedTask = value;

    this.selectedTaskChange.emit(value);

    if (this._selectedTask) {
      this.UpdateRouteInfo();
    }

    if (this._selectedTask?.taskTracking?.length == 0) {
      this.loadTaskTrackingForTask(this._selectedTask.id);
    }

    this.pauses = [];

    if (this._selectedTask != null) {
      this._selectedTask.completeTaskSteps.forEach((x) => {
        if (x.pauses && x.pauses.length != 0) {
          this.pauses = this.pauses.concat(
            x.pauses.filter((p) => p.latitude && p.longitude && !p.isResume),
          );
        }
      });

      if (this._selectedTask.taskOrganisationSpecificSteps != null) {
        this._selectedTask.taskOrganisationSpecificSteps.forEach((x) => {
          if (x.pauses && x.pauses.length != 0) {
            this.pauses = this.pauses.concat(
              x.pauses.filter((p) => p.latitude && p.longitude && !p.isResume),
            );
          }
        });
      }

      this._selectedTask.customTaskActions.forEach((x) => {
        if (x.pauses && x.pauses.length != 0) {
          this.pauses = this.pauses.concat(
            x.pauses.filter((p) => p.latitude && p.longitude && !p.isResume),
          );
        }
      });
    }
    this.setPauseResumeInfo();
  }

  refreshWorkflows(job: IOrderInfo) {
    this.workFlows = job.tasks
      .filter((x) => x.checklist)
      .filter((x) => x.checklist.infoURL)
      .map((x) => {
        return {
          label: 'Workflow ' + x.vehicle.registrationNumber,
          icon: 'fa fa-external-link',
          command: () => {
            this.visitURL(x.checklist.infoURL);
          },
        };
      });

    //console.log("WORKFLOWS: ", this.workFlows);
    //console.log("TASKS: ", job.tasks);
  }

  setPauseResumeInfo() {
    let resumedTaskStepPauses: ITaskStepPause[] = [];

    if (this.pauses) {
      if (this._selectedTask != null) {
        // get all resumed pauses
        this._selectedTask.completeTaskSteps.map((t, i) => {
          if (t.pauses)
            resumedTaskStepPauses = resumedTaskStepPauses.concat(
              t.pauses.filter((x) => x.isResume && x.latitude && x.longitude),
            );
        });

        if (this._selectedTask.taskOrganisationSpecificSteps != null) {
          this._selectedTask.taskOrganisationSpecificSteps.map((t, i) => {
            if (t.pauses)
              resumedTaskStepPauses = resumedTaskStepPauses.concat(
                t.pauses.filter((x) => x.isResume && x.latitude && x.longitude),
              );
          });
        }
        this._selectedTask.customTaskActions.map((t, i) => {
          if (t.pauses)
            resumedTaskStepPauses = resumedTaskStepPauses.concat(
              t.pauses.filter((x) => x.isResume && x.latitude && x.longitude),
            );
        });
      }

      //for each pause find the resume info
      if (resumedTaskStepPauses)
        this.pauses.map((taskStepPause, index) => {
          if (taskStepPause.taskStepId != null) {
            // get max taskStepInfo where the taskStepId = current and time > current created on and is resume
            let resumeInfo = resumedTaskStepPauses.filter(
              (x) =>
                x.taskStepId == taskStepPause.taskStepId &&
                moment(taskStepPause.createdOn).isBefore(x.createdOn),
            );
            taskStepPause.resumeInfo = this.resumeInfo(resumeInfo, taskStepPause);
          }
          if (taskStepPause.organisationSpecificStepId != null) {
            // get max taskStepInfo where the taskStepId = current and time > current created on and is resume
            let resumeInfo = resumedTaskStepPauses.filter(
              (x) =>
                x.organisationSpecificStepId == taskStepPause.organisationSpecificStepId &&
                moment(taskStepPause.createdOn).isBefore(x.createdOn),
            );
            taskStepPause.resumeInfo = this.resumeInfo(resumeInfo, taskStepPause);
          }
          if (taskStepPause.customTaskActionId != null) {
            // get max taskStepInfo where the taskStepId = current and time > current created on and is resume
            let resumeInfo = resumedTaskStepPauses.filter(
              (x) =>
                x.customTaskActionId == taskStepPause.customTaskActionId &&
                moment(taskStepPause.createdOn).isBefore(x.createdOn),
            );
            taskStepPause.resumeInfo = this.resumeInfo(resumeInfo, taskStepPause);
          }
        });
    }
  }

  resumeInfo(resumeInfo: ITaskStepPause[], taskStepPause: ITaskStepPause): ITaskStepResumeInfo {
    if (resumeInfo && resumeInfo.length > 0)
      return <ITaskStepResumeInfo>{
        name: resumeInfo[0].name,
        createdOn: resumeInfo[0].createdOn,
        elapsed: moment
          .duration(moment(resumeInfo[0].createdOn).diff(moment(taskStepPause.createdOn)))
          .humanize(),
      };
    return null;
  }

  get selectedTask(): ITaskInfo {
    return this._selectedTask;
  }

  private routeInfo: any;

  private _isFullWidth: boolean;
  @Input('isFullWidth')
  set isFullWidth(value: boolean) {
    this._isFullWidth = !!value ? true : false;
  }

  get isFullWidth(): boolean {
    return this._isFullWidth;
  }

  private validStates = [
    JobStatus.Cancelled,
    JobStatus.Completed,
    JobStatus.Closed,
    JobStatus.Started,
  ];
  public showOrderTrack: boolean;
  public showRecordCustomerInfo: boolean = false;
  public newCustomerNote: string;
  public newDelayFailureCategory: IDelayFailureCategory;

  pdfLinkData: any[];
  jobTaggingInfo: any;
  showPotentialSuppliers: boolean = false;

  public delayFailureCategories: SelectItem[];

  protected readonly OrganisationTypeEnum = OrganisationTypeEnum;

  public taskSequenceEditMode: boolean = false;

  public taskSequencingEnabled: boolean = false;
  public multiOrderView: boolean = false;

  @Output() taskSequenceUpdated: EventEmitter<ITaskInfo[]> = new EventEmitter<ITaskInfo[]>();

  constructor(
    private userService: UserService,
    private mapService: MapService,
    private taskTypeHelper: TaskTypeHelper,
    private jobService: JobsService,
    private vmeInboxJobsService: VmeInboxJobsService,
    private messageService: MessageService,
    private delayFailureService: DelayFailureService,
    private eventService: EventService,
    private emailService: EmailService,
    private router: Router,
    private taskSequenceService: TaskSequenceService,
  ) {
    this.selectedTaskChange = new EventEmitter<ITaskInfo>();
    this._jobInfo = null;
  }

  ngOnInit() {
    this.pdfLinkData = [
      {
        label: 'Full PDF',
        icon: 'fa fa-file-pdf-o pdf-icon',
        command: () => {
          this.downloadTrack(false, false);
        },
      },
      {
        label: 'Full PDF (no condition)',
        icon: 'fa fa-file-pdf-o pdf-icon',
        command: () => {
          this.downloadTrack(false, true);
        },
      },
      {
        label: 'Summary PDF',
        icon: 'fa fa-file-pdf-o pdf-icon',
        command: () => {
          this.downloadTrack(true, false);
        },
      },
    ];
  }

  ngAfterViewInit() {
    if (this.job) {
      this.jobStatus = this.job.status ? this.job.status : this.job.statusId;
    }
  }

  refreshJobTasks(selectedTaskId: number = null) {
    this.tasks = [];

    if (this.job) {
      this.refreshWorkflows(this.job);

      //console.log("Getting job information for job: ", this.job);

      let jobNum = this.job.jobNumber ? this.job.jobNumber : this._jobNumber;

      if (this.showTaggingInfo && jobNum && !this.jobTaggingInfo) {
        this.vmeInboxJobsService.getJobTaggingInfo(jobNum).then((result) => {
          this.jobTaggingInfo = result;

          //console.log('Job tagging info: ', this.jobTaggingInfo.orderRequiredTagsDTOs);

          // group tags using tagSet to show full information
          this.jobTaggingInfo.orderRequiredTagsDTOs.forEach((x) => {
            x.tagSet = [];
            for (let i = 1; i <= 3; i++)
              x.tagSet[i - 1] = x.tags
                .filter((y) => y.tagSet == i)
                .flat()
                .map((item) => {
                  return item.tagEntity.name;
                })
                .join();

            x.tagsNot = x.tags
              .filter((y) => y.tagSet == 0)
              .flat()
              .map((item) => {
                return item.tagEntity.name;
              })
              .join();
            x.supplierCount = this.jobTaggingInfo.potentialSuppliers.length;
          });
        });
      }

      //this.showOrderTrack = (this.organisationTypeId == 1 || this.validStates.indexOf(this.job.status) > -1 || (this.job.statusId && this.validStates.indexOf(this.job.statusId) > -1)) ? true : false;
      this._job.tasks.forEach((item) => {
        this.tasks.push({ label: item.vehicle.registrationNumber, value: item });

        if (this.loadTaskFailures) {
          this.delayFailureService.getTaskDelayFailures(item.id).then((result) => {
            item.taskDelayFailures = result;
          });
        }
      });

      this.taskSequencingEnabled = this.tasks.some((task) => task.value.taskSequence != null);

      this.updateMultiOrderView();
      this.setTaskOrder();

      const t = selectedTaskId ? this._job.tasks.find((o) => o.id == selectedTaskId) : null;

      this.selectedTask = t ? t : this._job.tasks[0];

      if (this.selectedTask) {
        if (!this.currentUserOrgTypeId) {
          this.userService.getCurrentUserOrg().then((res) => {
            if (res) {
              this.organisationTypeId = res.organisationTypeId;
              this.getDelayFailureCategories();
              this.UpdateRouteInfo();
            }
          });
        } else {
          this.organisationTypeId = this.currentUserOrgTypeId;
          this.getDelayFailureCategories();
          this.UpdateRouteInfo();
        }
      }
    }
  }

  private updateMultiOrderView(): void {
    const uniqueOrderIds = new Set(this.tasks.map((task) => task.value.orderId));
    this.multiOrderView = uniqueOrderIds.size > 1;
  }

  private getDelayFailureCategories() {
    // get all active delay-failure categories
    if (this.organisationTypeId == OrganisationTypeEnum.Engineius) {
      this.delayFailureService.getDelayFailureCategories(true).then((result) => {
        this.delayFailureCategories = [{ label: '', value: null }];
        result.forEach((x) => {
          this.delayFailureCategories.push({
            label: `${x.category} (${DelayFailureAccountabilityEnum[x.accountable]})`,
            value: x,
          });
        });

        this.newDelayFailureCategory = null;
      });
    }
  }

  private setupDelayFailureEmailList() {
    let users: IUser[] = [];
    this.userService.getUsersFromCustomer(this.job.customerId).then((result) => {
      users = result;
      const userEmail = this.job?.user?.email;
      const matchingUser = users.find((user) => user.email === userEmail);

      if (matchingUser) {
        this.userEmails.push(matchingUser.email);
        this.emailAddressResult.push(matchingUser.email);
      }

      if (this.job.customerTeam) {
        if (this.job.customerTeam.primaryContactEmail) {
          this.emailAddressResult.push(this.job.customerTeam.primaryContactEmail);
        }
        if (this.job.customerTeam.secondaryContactEmail) {
          this.emailAddressResult.push(this.job.customerTeam.secondaryContactEmail);
        }
      }
      const otherUserEmails = users
        .filter((user) => user.email !== userEmail)
        .map((user) => user.email);

      this.userEmails.push(...otherUserEmails);
    });
  }

  setTaskOrder() {
    const hasSequencedTasks = this.tasks.some((task) => task.value.taskSequence != null);

    this.tasks.sort((a, b) => {
      if (hasSequencedTasks && !this.multiOrderView) {
        return a.value.taskSequence - b.value.taskSequence;
      }

      let dateA = new Date(a.value.pickupEarliestDateTime);
      let dateB = new Date(b.value.pickupEarliestDateTime);

      return +dateA - +dateB;
    });
  }

  UpdateRouteInfo() {
    this.showOrderTrack =
      this.organisationTypeId == 1 ||
      this.validStates.indexOf(this.job.status) > -1 ||
      (this.job.statusId && this.validStates.indexOf(this.job.statusId) > -1)
        ? true
        : false;
    this.routeInfo = { distanceMiles: null, time: null };
    var Url = window.location.href;

    const mtrph = 0.000621371192;

    const urlParams = `?o=${encodeURIComponent(
      this.job.orderNumber.toString(),
    )}&r=${encodeURIComponent(this.selectedTask.vehicle.registrationNumber)}`;

    this.FullOrderUrl = Url.substring(0, Url.indexOf('/app')) + `/Track${urlParams}`;
    this.FullOrderPDFUrl = `/Track/Report-DynamicPdf2${urlParams}`;
    this.SummaryOrderPDFUrl = `/Track/Report-Summary${urlParams}`;
    this.SummaryOrderUrl = Url.substring(0, Url.indexOf('/app')) + `/Track/Summary${urlParams}`;

    if (
      !this.selectedTask ||
      !this.selectedTask.pickupLocation ||
      !this.selectedTask.dropoffLocation
    ) {
      return;
    }

    var origin = [];

    if (this.selectedTask.pickupLocation.latitude) {
      origin.push(this.selectedTask.pickupLocation.latitude);
    }

    if (this.selectedTask.pickupLocation.longitude) {
      origin.push(this.selectedTask.pickupLocation.longitude);
    }

    var destination = [];

    if (this.selectedTask.dropoffLocation.latitude) {
      destination.push(this.selectedTask.dropoffLocation.latitude);
    }

    if (this.selectedTask.dropoffLocation.longitude) {
      destination.push(this.selectedTask.dropoffLocation.longitude);
    }

    // convert timespan string to seconds
    if (this.selectedTask.estimateTime) {
      this.routeInfo.time = this.mapService.getTravelTimeFormatted(this.selectedTask.estimateTime);
      this.routeInfo.distanceMiles = this.mapService.getMiles(this.selectedTask.distance);
    }

    //Chart
    var ChartLabel = [];
    var arrvar;
    var distcnt = 0;
    var distYaxis = 1;
    var Hours;
    var Minutes;
    var diff = 0;
    var diff1 = 0;
    var dist = 0;
    var SpeedData = [];
    var DistData = [];
    var BatteryData = [];
    var BatteryCharge = [];
    var BatteryChargeLabel = { 0: '', 1: 'OFF', 2: 'ON', 3: '' };
    var BatteryChargeColor = [];
    var mtrps = 2.237;
    if (
      this.selectedTask.taskTracking &&
      this.selectedTask.taskTracking.length > 0 &&
      this.organisationTypeId != 2
    ) {
      this.TaskTrack = 1;
      const digits = 2;
      const round = (x) =>
        x.toLocaleString(undefined, {
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        });
      const batdigits = 0;
      const batround = (x) =>
        x.toLocaleString(undefined, {
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        });

      this.selectedTask.taskTracking.forEach((va) => {
        let value: any = {};
        if (va.isHeading == false) {
          arrvar = new Date(va.timestamp);
          Hours = arrvar.getHours();
          Minutes = arrvar.getMinutes();
          if (Hours < 10) {
            Hours = '0' + Hours;
          }
          if (Minutes < 10) {
            Minutes = '0' + Minutes;
          }
          arrvar = Hours + ':' + Minutes;
          ChartLabel.push(arrvar);

          arrvar = va.speed * mtrps;
          if (arrvar < 0) {
            arrvar = 0;
          }
          SpeedData.push(round(arrvar));

          arrvar = va.batteryLevel * 100;
          if (arrvar < 0) {
            arrvar = 0;
          }
          BatteryData.push(batround(arrvar));

          if (va.isBatteryCharging) {
            arrvar = 2;
          } else {
            arrvar = 1;
          }
          BatteryCharge.push(arrvar);
          if (arrvar == 2) {
            BatteryChargeColor.push('#0083c9');
          } else {
            //BatteryChargeColor.push('#6fc0e8');
            BatteryChargeColor.push('#0083c9');
          }
          //console.log(BatteryCharge);

          if (dist == 0) {
            dist = va.odometer;
            arrvar = diff;
          } else {
            //diff1 = va.odometer - dist
            //if (diff1 >= 0) {
            //	diff = diff + diff1;
            //}
            diff = diff + (va.odometer - dist);
            arrvar = diff * mtrph;
            dist = va.odometer;
          }
          if (arrvar <= 10) {
            distYaxis = 1;
          } else if (arrvar > 10 && arrvar <= 100) {
            distYaxis = 10;
          } else if (arrvar > 100 && arrvar <= 150) {
            distYaxis = 15;
          } else if (arrvar > 150 && arrvar <= 200) {
            distYaxis = 20;
          } else if (arrvar > 200 && arrvar <= 250) {
            distYaxis = 25;
          } else if (arrvar >= 300) {
            distYaxis = 30;
          }
          DistData.push(round(arrvar));
          //console.log(DistData);
          // test values
          //arrvar = distcnt;
          //if (distcnt <= 10) {
          //	distYaxis = 1;
          //}
          //else if(distcnt > 10 && distcnt <= 100) {
          //	distYaxis = 10;
          //}
          //else if (distcnt > 100 && distcnt <= 150) {
          //	distYaxis = 15;
          //}
          //else if (distcnt > 150 && distcnt <= 200) {
          //	distYaxis = 20;
          //}
          //else if (distcnt > 200 && distcnt <= 250) {
          //	distYaxis = 25;
          //}
          //else if (distcnt >= 300) {
          //	distYaxis = 30;
          //}
          //distcnt = distcnt + .2;
          //DistData.push(round(arrvar))
        }
      });
      //console.log(ChartLabel);
      //console.log(SpeedData);
      //console.log(BatteryData);
      //console.log(DistData);

      this.DriverLineOptions = {
        scaleShowValues: true,
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          yAxes: [
            {
              id: 'Speed',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
                stepSize: 10,
                fontColor: '#0083c9',
              },
              gridLines: {
                color: 'rgba(0, 131, 201, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: 'Speed (MPH)',
                fontColor: '#0083c9',
                fontFamily: 'Arial',
                fontStyle: 'normal',
                fontSize: 16,
                padding: 6,
                lineHeight: 2,
              },
            },
            {
              id: 'Distance',
              type: 'linear',
              position: 'right',
              ticks: {
                autoSkip: true,
                beginAtZero: true,
                stepSize: distYaxis,
                fontColor: '#cc0055',
              },
              gridLines: {
                color: 'rgba(204, 0, 85, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: 'Distance (Miles)',
                fontColor: '#cc0055',
                fontFamily: 'Arial',
                fontStyle: 'normal',
                fontSize: 16,
                padding: 6,
                lineHeight: 2,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: true,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      };

      this.DriverLineData = {
        labels: ChartLabel,
        datasets: [
          {
            label: 'Speed (MPH)',
            //backgroundColor: '#cc4e0e',
            borderColor: '#0083c9',
            yAxisID: 'Speed',
            //lineTension: 0,
            fill: false,
            data: SpeedData,
          },
          {
            label: 'Distance (Miles)',
            //backgroundColor: '#565656',
            borderColor: '#cc0055',
            yAxisID: 'Distance',
            //lineTension: 0,
            fill: false,
            data: DistData,
          },
        ],
      };

      this.BatteryLineOptions = {
        scaleShowValues: true,
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        tooltips: {
          enabled: false,
        },
        scales: {
          yAxes: [
            {
              id: 'BatteryCharge',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
                stepSize: 1,
                max: 3,
                fontColor: '#0083c9',
                callback: function (value, index, values) {
                  return BatteryChargeLabel[value];
                },
              },
              gridLines: {
                color: 'rgba(0, 131, 201, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: 'Battery Charging',
                fontColor: '#0083c9',
                fontFamily: 'Arial',
                fontStyle: 'normal',
                fontSize: 16,
                padding: 6,
                lineHeight: 2,
              },
            },
            {
              id: 'Battery',
              type: 'linear',
              position: 'right',
              ticks: {
                beginAtZero: true,
                stepSize: 20,
                max: 100,
                fontColor: '#012269',
              },
              gridLines: {
                color: 'rgba(204, 0, 85, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: 'Battery Percentage',
                fontColor: '#012269',
                fontFamily: 'Arial',
                fontStyle: 'normal',
                fontSize: 16,
                padding: 6,
                lineHeight: 2,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: true,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      };

      this.BatteryLineData = {
        labels: ChartLabel,
        datasets: [
          {
            label: 'Battery Percentage',
            //backgroundColor: '#0083c9',
            borderColor: '#012269',
            yAxisID: 'Battery',
            data: BatteryData, //,
            //type: 'line'
          },
          {
            label: 'Battery Charging',
            //backgroundColor: BatteryChargeColor,
            borderColor: '#0083c9',
            yAxisID: 'BatteryCharge',
            data: BatteryCharge,
          },
        ],
      };
    } else {
      this.TaskTrack = 0;
    }
    //Chart
    //alert("Type");
    //alert(this.organisationTypeId);
    //alert("Track");
    //alert(this.TaskTrack);
  }

  recordCustomerInfo() {
    this.showRecordCustomerInfo = true;
    this.setupDelayFailureEmailList();
  }

  private setupDelayFailureTemplate(newNotes: string): IDelayFailureTemplate {
    if (this.newDelayFailureCategory.delayFailureTemplate) {
      this.newDelayFailureCategory.delayFailureTemplate.bodyTemplate = newNotes;
      this.newDelayFailureCategory.delayFailureTemplate.recipientAddressTemplate =
        this.emailAddressResult.join(',');
      return this.newDelayFailureCategory.delayFailureTemplate;
    }
  }

  SaveNewCustomerNote() {
    if (!this.newDelayFailureCategory) {
      this.messageService.add(Message.Error('No delay/failure reason selected'));
      return;
    }

    this.showRecordCustomerInfo = false;

    // add task delay/failure record
    if (this.newDelayFailureCategory) {
      const dto = <ITaskDelayFailure>{
        taskId: this.selectedTask.id,
        delayFailureCategoryId: this.newDelayFailureCategory.id,
        delayFailureTemplate: this.emailToggle
          ? this.setupDelayFailureTemplate(this.newCustomerNote)
          : undefined,
      };
      this.delayFailureService.addTaskDelayFailure(dto).then(() => {
        //console.log("Delay/failure added to selected task");

        // remove delay reason required flag from current task
        this.selectedTask.requiresDelayFailureReason = false;

        // raise event so failure component on job details screen can refresh
        this.eventService.DelayFailureRefreshEvent.emit();

        this.clearDelayFailureNotesAndSelection();
        this.emailToggle = true;

        // refresh data
        this.refreshJobTasks(this.selectedTask.id);
      });
    }
  }

  clearDelayFailureNotesAndSelection() {
    this.newCustomerNote = null;
    this.newDelayFailureCategory = null;
    this.emailAddressResult = [];
    this.showRecordCustomerInfo = false;
  }

  showTaggingSuppliers() {
    this.showPotentialSuppliers = true;
  }

  getSupplierAddress(item) {
    return `${item.addressLine1}, ${item.addressLine2}, ${item.addressLine3}`;
  }

  getSupplierTags(item) {
    return item.organisationTags
      .map((item) => {
        return item.tagEntity.name;
      })
      .join();
  }

  getTaskType() {
    return this.taskTypeHelper.getTaskTypeName(this.selectedTask.taskTypeId);
  }

  ShowTrackURL() {
    this.showCopyTrackURL = true;
    let lbl = document.getElementById('lblMsg') as HTMLLabelElement;
    this.showlblMsg = false;
  }

  CopyUrl(index: number) {
    let copyUrl = document.getElementById('txtUrl' + index) as HTMLInputElement;
    let lbl = document.getElementById('lblMsg') as HTMLLabelElement;
    this.showlblMsg = true;
    copyUrl.style.display = 'block';
    copyUrl.select();
    document.execCommand('copy');
    copyUrl.style.display = 'none';
    console.log(this.showlblMsg);
  }

  downloadTrack(summaryOnly: boolean, hideDamage: boolean) {
    let uri = summaryOnly ? this.SummaryOrderPDFUrl : this.FullOrderPDFUrl;
    this.pdfDownloading = true;

    uri += '&hd=' + hideDamage;

    this.jobService.downloadPDF(uri).subscribe(
      (x) => {
        FileSaver.saveAs(x);
      },
      (error) => {
        this.messageService.add(Message.Error('Error downloading PDF'));
        this.pdfDownloading = false;
      },
      () => {
        this.pdfDownloading = false;
      },
    );
  }

  getPDFIcon() {
    if (this.pdfDownloading) return 'fa fa-spinner fa-spin';
    else return 'fa fa-file-pdf-o pdf-icon';
  }

  visitURL(infoURL: string) {
    window.open(infoURL, '_blank');
  }

  onDelayFailureCategoryChange() {
    if (this.newDelayFailureCategory.delayFailureTemplate) {
      this.delayFailureService
        .getRenderedDelayFailureTemplate(
          this.selectedTask.id,
          this.newDelayFailureCategory.delayFailureTemplateId,
        )
        .then((delayTemplate) => {
          this.newCustomerNote = delayTemplate.bodyTemplate;
        });
    }
  }

  //Whether to send email or not.
  public emailToggle = true;
  //The users that are assigned to this job
  private userEmails: string[] = [];
  //Suggestions
  public emailAddressSuggestions: string[] = [];
  //The email address
  public emailAddressResult: string[] = [];
  @ViewChild('autocomplete') autocomplete: AutoComplete;
  //email regex
  private emailRegExp = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
  private emailRegExpCommas = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})),$/,
  );
  filterEmailAddress(event: AutoCompleteCompleteEvent) {
    const validEmail = this.emailRegExp.test(event.query);

    if (validEmail) {
      this.emailAddressSuggestions = [event.query, ...Object.values(this.userEmails)];
    } else {
      this.emailAddressSuggestions = Object.values(this.userEmails);
    }
    this.autoMarkEmail(event.query);
  }

  autoMarkEmail(email: string) {
    const validEnteredEmail = this.emailRegExpCommas.test(email);
    //Unfortunately, there isn't a way to get the clear the input of autocomplete, so we have to find it via
    // child element
    if (validEnteredEmail) {
      const newEmail = email.slice(0, -1);
      this.emailAddressResult.push(newEmail);
      //ul > li > input
      const ulElement = this.autocomplete.el.nativeElement?.childNodes[0]?.children[0];
      if (ulElement) {
        ulElement.lastChild.lastChild.value = '';
      }
    }
  }

  loadTaskTrackingForTask(taskId: number): void {
    // if (!this.job.supplierId) {
    //   return;
    // }
    this.jobService
      .getTaskTrackingInfo(this._job.tasks[0].jobId, taskId)
      .then((taskTrackingInfo) => {
        if (taskTrackingInfo && taskTrackingInfo.length > 0) {
          this.selectedTask = { ...this.selectedTask, taskTracking: taskTrackingInfo };
          this.UpdateRouteInfo();
        }
      });
  }

  editLocations(taskId) {
    //this.showEditLocationsDialog = true;
    this.router.navigate(['/app/edit-task-location/' + taskId], {
      queryParams: { backTo: this.router.url },
    });
  }

  hasAssignedSupplier(): boolean {
    return this.jobInfo?.supplier ? true : false;
  }

  isJobCompleted(jobInfo: IJobScreen): boolean {
    if (!jobInfo) {
      return false;
    }
    return jobInfo.statusId === this.jobStatus_Completed;
  }

  handleTaskSequenceToggle(event: any): void {
    let enabled = event.checked;

    if (enabled) {
      this.enableTaskSequencing();
    } else {
      this.disableTaskSequencing();
    }
  }

  enableTaskSequencing(): void {
    this.tasks.forEach((task, index) => {
      task.value.taskSequence = index + 1;
    });

    this.saveTaskSequence(true);

    this.refreshJobTasks();
  }

  disableTaskSequencing(): void {
    this.tasks.forEach((task, index) => {
      task.value.taskSequence = null;
    });

    this.saveTaskSequence(true);

    this.refreshJobTasks();
  }

  editTaskSequence(): void {
    this.taskSequenceEditMode = true;
    this.tasksCopyForSequenceEdit = cloneDeep(this.tasks);
  }

  moveTaskSequenceDown(task: SelectItem) {
    const index = this.tasksCopyForSequenceEdit.indexOf(task);
    if (index !== -1 && index < this.tasksCopyForSequenceEdit.length - 1) {
      [this.tasksCopyForSequenceEdit[index], this.tasksCopyForSequenceEdit[index + 1]] = [
        this.tasksCopyForSequenceEdit[index + 1],
        this.tasksCopyForSequenceEdit[index],
      ];
      this.updateTaskSequenceIds(this.tasksCopyForSequenceEdit);
    }
  }

  moveTaskSequenceUp(task: SelectItem) {
    const index = this.tasksCopyForSequenceEdit.indexOf(task);
    if (index > 0) {
      [this.tasksCopyForSequenceEdit[index], this.tasksCopyForSequenceEdit[index - 1]] = [
        this.tasksCopyForSequenceEdit[index - 1],
        this.tasksCopyForSequenceEdit[index],
      ];
      this.updateTaskSequenceIds(this.tasksCopyForSequenceEdit);
    }
  }

  updateTaskSequenceIds(tasks: SelectItem[]): void {
    tasks.forEach((task, i) => {
      task.value.taskSequence = i + 1;
    });
  }

  cancelTaskSequenceEdit(): void {
    this.taskSequenceEditMode = false;
  }

  saveTaskSequence(bypassClone: boolean = false): void {
    if (!bypassClone) {
      this.tasks = cloneDeep(this.tasksCopyForSequenceEdit);
    }

    this.taskSequenceEditMode = false;
    const taskValues = this.tasks.map((task) => task.value);
    this.taskSequenceUpdated.emit(taskValues);

    if (this.job.id > 0) {
      this.taskSequenceService
        .updateTaskSequences(this.tasks.map((task) => task.value))
        .then(() => {
          this.messageService.add(Message.Success('Task sequence updated successfully.'));
        })
        .catch(() => {
          this.messageService.add(
            Message.Error('An error occurred when attempting to update this task sequence'),
          );
        });
    } else {
      this.messageService.add(Message.Success('Task sequence updated successfully.'));
    }
  }
}
